import { parseLooseYmd, todayYmd } from "../../features/cases/dates";

// auction_dates is a JSON array of alternating dates:
// [posted, held, posted, held, …] (see normalizeAuctionDates). Returns
// [{ posted, postedYmd, date, ymd }] sorted by auction date; never throws.
// Cached per row object (rows are replaced, not mutated, on refetch).
const cache = new WeakMap();

export const auctionsOf = (row) => {
  if (!row) return [];
  if (cache.has(row)) return cache.get(row);
  let list = [];
  try {
    const raw = JSON.parse(row.auction_dates || "[]");
    if (Array.isArray(raw)) {
      for (let i = 0; i + 1 < raw.length; i += 2) {
        list.push({
          posted: raw[i],
          postedYmd: parseLooseYmd(raw[i]),
          date: raw[i + 1],
          ymd: parseLooseYmd(raw[i + 1]),
        });
      }
    }
  } catch {
    list = [];
  }
  list.sort((a, b) => (a.ymd ?? 0) - (b.ymd ?? 0));
  cache.set(row, list);
  return list;
};

// The nearest upcoming auction, else the most recent one.
export const nextAuction = (row) => {
  const list = auctionsOf(row);
  if (!list.length) return null;
  const today = todayYmd();
  return list.find((a) => a.ymd && a.ymd >= today) ?? list[list.length - 1];
};

export const lastPosted = (row) =>
  auctionsOf(row).reduce(
    (latest, a) => (a.postedYmd && (!latest || a.postedYmd > latest.postedYmd) ? a : latest),
    null
  );

// Distinct auction dates with how many postings mention each: "dd/mm/yyyy (n)".
export const auctionDatesSummary = (row) => {
  const counts = new Map();
  auctionsOf(row).forEach((a) => counts.set(a.date, (counts.get(a.date) ?? 0) + 1));
  return [...counts.entries()].map(([date, n]) => `${date} (${n})`).join(", ");
};
